import loadRemoteScript from 'lib/load-remote-script'
import Conversion from './conversion'

(function (f, b, e, v, n) {
  if (f.fbq) return
  n = f.fbq = function () {
    n.callMethod
      ? n.callMethod.apply(n, arguments)
      : n.queue.push(arguments)
  }
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = !0
  n.version = '2.0'
  n.queue = []
}(window, document))

export default class MetaPixel extends Conversion {
  constructor ({ pixelIDs = [], ...rest } = {}) {
    super(rest)
    this.fbq = null
    this.pushWithoutInstall = true
    this.pixelIDs = pixelIDs
    this.initializedIDs = []
    this.setupMaybe()
  }

  async install () {
    this.installPromise = await loadRemoteScript({ url: 'https://connect.facebook.net/en_US/fbevents.js' })
  }

  async addID (id) {
    console.debug('addId', id)
    this.setupCompleted = false
    this.pixelIDs.push(id)
    await this.setup()
  }

  async setup () {
    this.setupInProgress = true
    let id = this.pixelIDs.pop()
    while (id) {
      // prevents init same id multiple times
      if (this.initializedIDs.indexOf(id) < 0) {
        console.debug('setup', 'init', id)
        this.push('init', id)
        this.initializedIDs.push(id)
      }
      id = this.pixelIDs.pop()
    }
    this.setupInProgress = false
    this.setupCompleted = false
  }

  get shouldSetup () { return super.shouldSetup && !this.setupInProgress }
  // get setupCompleted () { return this.pixelIDs.length == 0 }

  deliver (item) {
    window.fbq.push(item)
  }

  static formatItems (...items) {
    return items.map(item => this.formatItem(item))
  }

  // this should destruct the event object and return an array for gtag
  static formatItem (item) {
    if (!(item instanceof Array)) {
      return this.eventObjectToArray(this.adaptItem(item))
    }

    return item
  }

  static adaptItem ({ type, event, ...rest }) {
    switch (event) {
      case 'AddToCart':
      case 'InitiateCheckout':
      case 'Purchase':
        return this.adaptConversionEvent({ type, event, ...rest })
      case 'ViewContent':
        return this.adoptContentViewEvent({ type, event, ...rest })
      default:
        return { type, event, ...rest }
    }
  }

  // see Order#asConversion()
  // this methods introduces "extra" prop that will be used to pass the eventID

  static adaptConversionEvent ({ type, event, ...data }) {
    const { transaction_id, value, items } = data
    return {
      type,
      event,
      extra: { eventID: transaction_id },
      data: {
        content_type: 'product',
        content_ids: items.map(({ item_id }) => item_id),
        currency: 'USD',
        value,
        num_items: items.length,
        contents: items.map(({ item_id, quantity }) => { return { id: item_id, quantity } }),
      },
    }
  }

  static adoptContentViewEvent ({ type, event, ...data }) {
    const { items, currency, value } = data
    return {
      type,
      event,
      data: {
        content_type: 'product',
        currency,
        value,
        content_ids: items.map(({ item_id }) => item_id),
      },
    }
  }

  static eventObjectToArray ({ type, event, data, extra }) {
    return [this.mapEventType(type), event, data, extra].filter(item => !!item)
  }

  static mapEventType (type) {
    return type === 'event' ? 'track' : type
  }

  static eventNamesMap = {
    page_view: 'PageView',
    add_to_cart: 'AddToCart',
    begin_checkout: 'InitiateCheckout',
    purchase: 'Purchase',
    view_item: 'ViewContent',
  }

  static ignoredEvents = ['view_home_page', 'remove_from_cart']
}
